import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";
import { Typo } from "@pepperstone/pepper-ui-kit";

export const NewClientsTableSkeleton = ({ title }: { title?: string }) => {
  return (
    <div className="w-full" data-testid="new-clients-skeleton">
      <div className="mx-auto rounded-2xl border border-stroke-primary bg-surface-base-background shadow-sm">
        <div className="flex items-center justify-between border-b border-stroke-primary p-6">
          <Typo
            elem="h1"
            type="label"
            size="lg"
            textColor="ps-text-text-primary-base"
          >
            {title}
          </Typo>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-stroke-primary">
                <th className="px-6 py-4 text-left">
                  <SkeletonLoader
                    variant="rectangular"
                    height={20}
                    width={200}
                  />
                </th>
                <th className="px-6 py-4 text-left">
                  <SkeletonLoader
                    variant="rectangular"
                    height={20}
                    width={180}
                  />
                </th>
                <th className="px-6 py-4 text-right">
                  <SkeletonLoader
                    variant="rectangular"
                    height={20}
                    width={120}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 4 }).map((_, index) => (
                <tr key={index} className="border-b border-stroke-primary">
                  <td className="px-6 py-4">
                    <SkeletonLoader
                      variant="rectangular"
                      height={20}
                      width={250}
                    />
                  </td>
                  <td className="px-6 py-4">
                    <SkeletonLoader
                      variant="rectangular"
                      height={20}
                      width={180}
                    />
                  </td>
                  <td className="px-6 py-4 text-right">
                    <SkeletonLoader
                      variant="rectangular"
                      height={20}
                      width={120}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
